<!--suppress TypeScriptUnresolvedVariable -->
<div class="app-tree">
    <div *ngIf="!hierarchy" class="pt-20 pl-24" fxLayout="row inline" fxFlexAlign="center">
        <mat-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading resources hierarchy'|i18n}}...</span>
    </div>
    <ng-container *ngIf="hierarchy">
        <div fxLayout="row" fxLayoutAlign="end" class="pt-4 pr-4">
            <button mat-button class="clear-selection-button" [title]="'Clear selection'|i18n" color="warn"
                    (click)="onSelectEntity(null)">
                <app-icon name="fal-eraser"></app-icon>
            </button>
        </div>
        <div class="tree-container">
            <mat-tree class="entity-tree" [dataSource]="dataSource" [treeControl]="treeControl">
                <mat-tree-node *matTreeNodeDef="let node"
                               matTreeNodePadding matTreeNodePaddingIndent="25"
                               [ngClass]="{'node-dragging': dragInfo && dragInfo.draggedEntity?.id === node.entity.id, 'collapsed': !searchMatches(node)}">
                    <!-- use a disabled button to provide padding -->
                    <div fxLayout="column" *ngIf="searchMatches(node)">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <div [style.visibility]="!dragInfo || dragInfo.draggedEntity?.id !== node.entity.id ? 'visible' : 'hidden'">
                                <button *ngIf="!node.expandable" mat-icon-button disabled></button>
                                <ng-container *appVar="treeControl.isExpanded(node) as expanded">
                                    <!-- NOTE: when click handler is called, `expanded` has already been updated! -->
                                    <button *ngIf="node.expandable" mat-icon-button matTreeNodeToggle
                                            (click)="onToggleExpansion(node, expanded)">
                                        <app-icon
                                                [name]="expanded ? 'fal-chevron-down' : 'fal-chevron-right'">
                                        </app-icon>
                                    </button>
                                </ng-container>
                            </div>
                            <ng-container *appVar="canBeSelected(node) as selectable">
                                <div *appVar="sameEntity(node.entity, selection) as selected"
                                     cdkDrag [cdkDragDisabled]="!isDraggable(node)"
                                     cdkDragBoundary=".tree-container"
                                     (cdkDragStarted)="onStartDragNode($event, node)"
                                     (cdkDragEnded)="onEndDragNode()"
                                     (cdkDragMoved)="onMoveDragNode($event)"
                                     class="draggable-tree-node"
                                     [ngClass]="{'drag-intersected': dragInfo && dragInfo.intersectedEntity?.id === node.entity.id}"
                                     [attr.data-nodeId]="node.entity.id">
                                    <span class="entity-element"
                                          (click)="selectable ? onSelectEntity(node.entity) : false"
                                          [ngClass]="{'selected': selected, 'disabled': !selectable}">
                                        <span>
                                            <app-icon *ngIf="node.entity|entityIcon; let icon"
                                                      [name]="icon">
                                            </app-icon>
                                        </span>
                                        &nbsp;
                                        <span>
                                            {{node.entity.name}}
                                        </span>
                                    </span>

                                </div>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="isEditable(node) && !dragInfo">
                            <ng-container *ngTemplateOutlet="nodeEditor; context:{node: node}">
                            </ng-container>
                        </ng-container>
                    </div>
                </mat-tree-node>
            </mat-tree>
        </div>
        <div class="search-resource">
            <mat-form-field appearance="standard">
                <app-icon matPrefix name="fal-search" class="text-primary pr-8"></app-icon>
                <input type="text" matInput autocomplete="off"
                       [spellcheck]="false" [placeholder]="'Search for resource'|i18n" [(ngModel)]="searchText">
                <button mat-button matSuffix class="search-clear-button text-light-warning"
                        [style.visibility]="searchText && searchText.length ? 'visible' : 'hidden'"
                        (click)="onClickClearSearchText()">
                    <app-icon name="fal-times"></app-icon>
                </button>
            </mat-form-field>
        </div>
    </ng-container>
</div>

<ng-template #nodeEditor let-node="node">
    <div fxLayout="row" fxLayoutAlign="center" class="node-editor">
        <div>
            <button mat-button class="edit-button"
                    [disabled]="!canBeMovedToRoot(node)"
                    (click)="onClickMoveToRoot(node)">
                <app-icon name="fal-level-up-alt" [title]="'Move to root-level'|i18n"></app-icon>
            </button>
        </div>
        <div>
            <button mat-button class="edit-button"
                    [disabled]="!canBeSorted(node, 'up')"
                    (click)="onClickSort(node, 'up')">
                <app-icon name="fal-arrow-up" [title]="'Move up'|i18n"></app-icon>
            </button>
        </div>
        <div>
            <button mat-button class="edit-button"
                    [disabled]="!canBeSorted(node, 'down')"
                    (click)="onClickSort(node, 'down')">
                <app-icon name="fal-arrow-down" [title]="'Move down'|i18n"></app-icon>
            </button>
        </div>
        <div>
            <button mat-button class="edit-button"
                    [disabled]="!canBeRenamed(node)"
                    (click)="onClickRename($event, node)">
                <app-icon name="fal-edit" [title]="'Rename resource'|i18n"></app-icon>
            </button>
        </div>
        <div>
            <button mat-button class="edit-button"
                    [disabled]="!canBeTagged(node)"
                    (click)="onClickTag($event, node)">
                <app-icon name="fal-tags" [title]="'Tag resource'|i18n"></app-icon>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #entityRename let-data>
    <div fxLayout="column">
        <div fxLayout="row" class="mb-24">
            <strong>{{data.entity.path|nicePath}}</strong>
        </div>
        <form>
            <div fxLayout="row" fxLayoutAlign="stretch center" fxLayoutGap="2rem">
                <mat-form-field class="name mr-16">
                    <input matInput [placeholder]="'Name'|i18n" [formControl]="data.nameFormControl"
                           [maxLength]="data.maxLength">
                    <mat-error *ngIf="data.nameError() === 'duplicate'">
                        {{'Resource {0} already exists'|i18n:data.nameFormControl.value.trim()}}
                    </mat-error>
                    <mat-error *ngIf="data.nameError() === 'pattern'">
                        {{'Characters {0} are invalid'|i18n:data.forbiddenChars}}
                    </mat-error>
                    <mat-error *ngIf="data.nameError() === 'invalid'">
                        {{'Invalid name'|i18n}}
                    </mat-error>
                </mat-form-field>
                <div>
                    <button mat-stroked-button color="primary" type="submit"
                            [disabled]="!data.nameFormControl.valid"
                            [mat-dialog-close]="data.nameFormControl.value.trim()">
                        <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
                        {{'Rename'|i18n}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #entityTag let-data>
    <div fxLayout="column">
        <div fxLayout="row" class="mb-24">
            <strong>{{data.entity.path|nicePath}}</strong>
        </div>
        <form>
            <div fxLayout="row" fxLayoutAlign="stretch center" fxLayoutGap="2rem">
                <mat-form-field class="tags mr-16">
                    <mat-chip-list #tagList>
                        <!--suppress TypeScriptUnresolvedFunction -->
                        <mat-chip *ngFor="let tag of data.tags" [selectable]="false" [removable]="true"
                                  (removed)="data.removeTag(tag, data.tags)">
                            {{tag}}
                            <app-icon matChipRemove name="fal-times-circle"></app-icon>
                        </mat-chip>
                        <!--suppress TypeScriptUnresolvedFunction -->
                        <input #tagsInput [placeholder]="'Tags'|i18n" (focus)="tagsInput.placeholder = ''"
                               [matChipInputFor]="tagList"
                               [matChipInputSeparatorKeyCodes]="data.separatorKeysCodes"
                               [matChipInputAddOnBlur]="true"
                               (matChipInputTokenEnd)="data.addTag($event, data.tags)">
                    </mat-chip-list>
                </mat-form-field>
                <div>
                    <button mat-stroked-button color="primary" type="submit"
                            [mat-dialog-close]="data.tags">
                        <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
                        {{'Tag'|i18n}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #entityMove let-data>
    <h1 mat-dialog-title>{{'Move {0}'|i18n:(data.entity.path|nicePath)}}</h1>
    <div mat-dialog-content fxLayout="column">
        <span *ngIf="!data.moveUnderRoot">
            {{'Are you sure you want to move {0} under {1}?'|i18n:(data.entity.path|nicePath:false):(data.moveUnder.path|nicePath:false)}}
        </span>
        <span *ngIf="data.moveUnderRoot">
            {{'Are you sure you want to move {0} under root?'|i18n:(data.entity.path|nicePath:false)}}
        </span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="warn" type="submit"
                [mat-dialog-close]="true">
            <app-icon [name]="data.moveUnder ? 'fal-location-arrow' : 'fal-level-up-alt'"></app-icon>&nbsp;&nbsp;
            {{'Move'|i18n}}
        </button>
    </div>
</ng-template>
